
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
     
      <el-form-item>
       
        <el-button
          size="small"
          type="primary"
          @click="handleEdit()"
          >添加班级</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="name" label="班级名称"> </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="班级名称" prop="name">
          <el-input
            size="small"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="请输入班级名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { classlist, classcreate, classdelete, classedit } from "@/api/userMG";
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        name: "",
        id: "",
      },
      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata() {
      classlist().then((res) => {
        this.listData = [];
        this.listData = res;
      
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.editFormVisible = true;
      this.editForm.name = "";
      this.editForm.name = "";
      this.editForm.id = "";
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.name = row.name;
        this.editForm.id = row.id;
      } else {
        this.title = "添加";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      console.log(this.editForm, 123);

      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (!this.editForm.id) {
            Reflect.deleteProperty(this.editForm, "id");
            classcreate(this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "添加成功！",
                });
                this.getdata();
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          } else {
            this.editForm.classId = String(this.editForm.id);
            Reflect.deleteProperty(this.editForm, "id");
            console.log();
            classedit(this.editForm.classId,this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "修改成功！",
                });
                this.getdata();
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          }
        } else {
          return false;
        }
      });
    },

    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          classdelete(row.id)
            .then((res) => {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getdata();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/class/classllits.vue